<script setup lang="ts">
import type { ParsedContent } from '@nuxt/content'
import type { PropType } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  class: {
    default: undefined,
    type: [
      String,
      Object,
      Array,
    ] as PropType<any>,
  },
  surround: {
    default: () => ({
      after: undefined,
      before: undefined,
    }),
    type: Object as PropType<{
      after?: ParsedContent
      before?: ParsedContent
    }>,
  },
  ui: {
    default: () => ({}),
    type: Object as PropType<Partial<typeof config>>,
  },
})

const config = {
  icon: {
    next: getIcon('arrowRight'),
    prev: getIcon('arrowLeft'),
  },
  link: {},
  wrapper: 'grid gap-8 sm:grid-cols-2',
}

const { attrs, ui } = useUI('content.surround', toRef(props, 'ui'), config, toRef(props, 'class'), true)
</script>

<template>
  <div
    :class="ui.wrapper"
    v-bind="attrs"
  >
    <SurroundLink
      v-if="surround.before"
      :icon="ui.icon.prev"
      :link="surround.before"
      :ui="ui.link"
    />

    <span
      v-else
      class="hidden sm:block"
    >
&nbsp;
    </span>

    <SurroundLink
      v-if="surround.after"
      class="text-right"
      :icon="ui.icon.next"
      :link="surround.after"
      :ui="ui.link"
    />
  </div>
</template>
